import { PropsWithChildren, useState } from "react";
import { ExpanderButton } from "./ExpanderButton";

export type ExpanderCardProps = {
    title: string,
    icon: string,
    buttonkey: string,
    defaultOpenState: boolean,
}

export function ExpanderCard(props: PropsWithChildren<ExpanderCardProps>) {
    const [openState, setOpenState] = useState<boolean>(props.defaultOpenState);

    return (
        <>
            <div className={`card card-white shadow mt-4`}>
                <div className={`card-header card-header-clicker`} data-bs-toggle="collapse" onClick={e => { setOpenState(!openState) }} data-bs-target={`#bdyCollapse_${props.buttonkey}`} aria-expanded={`${openState ? "false" : "true"}`} aria-controls={`bdyCollapse_${props.buttonkey}`}>
                    <div className="d-flex justify-content-between align-content-center">
                        <i className={`card-mini-icon ${props.icon}`}></i>
                        <div className="w-100">{props.title}</div>
                        <ExpanderButton state={!openState} />
                    </div>
                </div>
                <div className={`collapse multi-collapse ${openState ? "show" : ""}`} id={`bdyCollapse_${props.buttonkey}`}>
                    {props.children}
                </div>
            </div>
        </>
    );
}